import t from "dayjs";
import o from "../../../../node_modules/dayjs/plugin/utc.js";
import { ConditionalOperator as e } from "../../../../node_modules/gridify-client/dist/index.esm.js";
t.extend(o);
const n = (t2) => "date" === t2.type, d = (o2, e2) => t.utc(o2)[e2 ? "endOf" : "startOf"]("day").toISOString(), r = (t2, o2) => {
  const { key: n2, isDatetime: r2, value: i } = t2, { from: a, to: s } = i, m = a && s;
  if (m && o2.startGroup(), a) {
    const t3 = r2 ? d(a) : a;
    o2.addCondition(n2, e.GreaterThanOrEqual, t3);
  }
  if (m && o2.and(), s) {
    const t3 = r2 ? d(s, true) : s;
    o2.addCondition(n2, e.LessThanOrEqual, t3);
  }
  return m && o2.endGroup(), o2;
};
export {
  n as isDate,
  r as serializeDate,
  d as toIsoString
};
//# sourceMappingURL=serializeDate.js.map
